import {
  GET_CAMPAIGN_DATA_REQUEST,
  GET_CAMPAIGN_DATA_SUCCESS,
  GET_CAMPAIGN_DATA_FAILURE,
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  isFetched: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_DATA_REQUEST:
      return {
        data: [],
        isLoading: true,
        isFetched: false,
        error: null
      };

    case GET_CAMPAIGN_DATA_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        isFetched: true,
        error: null
      };

    case GET_CAMPAIGN_DATA_FAILURE:
      return {
        data: [],
        isLoading: false,
        isFetched: false,
        error: action.payload
      };

    default:
      return state;
  }
};
